import React, { Fragment, useContext, useEffect, useState } from 'react';

import { WsDeliverConfigSchemaMappingStatus, WsDeliverConfigWorkload } from '../../../enums';

import { WsDeliverConfigResourceItem, WsDeliverConfigSchemaItem, WsDeliverConfigSchemaMapping } from '../../../../../core/src/interfaces';


// import ApexCharts from 'apexcharts';

// import Chart from "react-apexcharts";




// import {
//   Chart as ChartJS,
//   // RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend,
// } from 'chart.js';

// import { Bar } from 'react-chartjs-2';

// import 'chart.js/auto';


import { apiGet } from '../../../helpers-sales';

import Loading from '../../Shared/Loading';





import ReactApexChart from "react-apexcharts";


import { getWorkloads } from "../data/deliver-data";




import './ConfigPage.scss';
import './ConfigTenant.scss';
import { asyncForEach } from "../../../helpers";
import { getSchemaMappingList, resourceTypeIsResource, resourceTypeIsValue, sortMappingList } from "../data/mapping-data";
import { WsResourceCoverage, WsWorkloadData } from "./ResourceCoverage";
import { useLocation } from "react-router-dom";
import { Panel, PanelType } from "office-ui-fabric-react";






// ChartJS.register(
//   // RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend
// );




const dscBackgroundColor = 'rgba(255, 206, 86, 0.3)';
const dscBorderColor     = 'rgba(232, 141, 24, 1)';

const powershellBackgroundColor = 'rgba(194, 211, 255, 0.4)';
const powershellBorderColor     = 'rgba(47, 108, 184, 1)';

const data2 = {
  labels: getWorkloads().map((item) => item.name),
  datasets: [
    {
      label: 'DSC',
      data: getWorkloads().map((item) => 50),
      backgroundColor: [
        dscBackgroundColor,
        dscBackgroundColor,
        dscBackgroundColor,
        dscBackgroundColor,
        dscBackgroundColor
      ],
      borderColor: [
        dscBorderColor,
        dscBorderColor,
        dscBorderColor,
        dscBorderColor,
        dscBorderColor
      ],
      // barThickness: 30,
      borderWidth: 1,
    },
    {
      label: 'PowerShell',
      data: getWorkloads().map((item) => 100),
      backgroundColor: [
        powershellBackgroundColor,
        powershellBackgroundColor,
        powershellBackgroundColor,
        powershellBackgroundColor,
        powershellBackgroundColor
      ],
      borderColor: [
        powershellBorderColor,
        powershellBorderColor,
        powershellBorderColor,
        powershellBorderColor,
        powershellBorderColor
      ],
      // barThickness: 30,
      borderWidth: 1,
    }
  ],
};

const options2: any = {
  // maintainAspectRatio: false, // Add this line
  indexAxis: 'y',  // This will make the chart horizontal
  scales: {
    x: {
      beginAtZero: true
    }
  },
  plugins: {
    legend: {
      display: true,
      position: 'top'
    }
  }
};







const getSeriesData = () => {

};



















export const getWorkloadSchemaCount = (workloadDataList: WsWorkloadData[], staticMappingList: WsDeliverConfigSchemaMapping[], source: string, mode: string, workload: WsDeliverConfigWorkload) => {
  const workloadDataItem = workloadDataList.find((item) => item.workload === workload);

  if (workloadDataItem) {

    return workloadDataItem[source].filter((item: WsDeliverConfigSchemaItem) => {
      if (mode === 'Resources') {
        return resourceTypeIsResource(item.type);
      } else {
        return resourceTypeIsValue(item.type);
      }
    }).length;

  } else {
    return 0;
  }
};




export const getWorkloadMappingCount = (workloadDataList: WsWorkloadData[], staticMappingList: WsDeliverConfigSchemaMapping[], mode: string, workload: WsDeliverConfigWorkload, status: WsDeliverConfigSchemaMappingStatus) => {
  const workloadDataItem = workloadDataList.find((item) => item.workload === workload);

  if (workloadDataItem) {
    // console.log('');
    // console.log(`getWorkloadMappingCount : ${workload} : ${status}`);
    // console.log(workloadDataItem);

    const schemaMappingList = getSchemaMappingList(workloadDataItem.sourceData, workloadDataItem.dscData, staticMappingList);
    // console.log(schemaMappingList);

    return schemaMappingList.filter((item) => {
      if (mode === 'Resources') {
        return item.status === status && resourceTypeIsResource(item.type);
      } else {
        return item.status === status && resourceTypeIsValue(item.type);
      }
    }).length;

  } else {
    return 0;
  }
};








const getSeries = (workloadDataList: WsWorkloadData[], staticMappingList: WsDeliverConfigSchemaMapping[], mode: string) => {

  

  // console.log('getSeries ===========================================================');
  // console.log(workloadDataList);

  const series: any  = [
    {
      name: 'Total',
      group: 'total',
      data: [
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.EntraId),
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.Exchange),
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.Intune),
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.SharePoint),
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.Teams),
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.OneDrive),
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.Planner),
        getWorkloadSchemaCount(workloadDataList, staticMappingList, 'sourceData', mode, WsDeliverConfigWorkload.SecurityCompliance),
      ]
    },
    // {
    //   name: 'Pending',
    //   group: 'split',
    //   data: [ 40, 1, 1, 1, 1, 1 ]
    // },
    {
      name: 'Mapped',
      group: 'split',
      data: [
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.EntraId,    WsDeliverConfigSchemaMappingStatus.Mapped),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Exchange,   WsDeliverConfigSchemaMappingStatus.Mapped),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Intune,     WsDeliverConfigSchemaMappingStatus.Mapped),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SharePoint, WsDeliverConfigSchemaMappingStatus.Mapped),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Teams,      WsDeliverConfigSchemaMappingStatus.Mapped),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.OneDrive,   WsDeliverConfigSchemaMappingStatus.Mapped),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Planner,    WsDeliverConfigSchemaMappingStatus.Mapped),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SecurityCompliance,    WsDeliverConfigSchemaMappingStatus.Mapped),
      ]
    }, {
      name: 'In Review',
      group: 'split',
      data: [
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.EntraId,    WsDeliverConfigSchemaMappingStatus.Review),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Exchange,   WsDeliverConfigSchemaMappingStatus.Review),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Intune,     WsDeliverConfigSchemaMappingStatus.Review),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SharePoint, WsDeliverConfigSchemaMappingStatus.Review),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Teams,      WsDeliverConfigSchemaMappingStatus.Review),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.OneDrive,   WsDeliverConfigSchemaMappingStatus.Review),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Planner,    WsDeliverConfigSchemaMappingStatus.Review),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SecurityCompliance,    WsDeliverConfigSchemaMappingStatus.Review),
      ]
    }, {
      name: 'Ignore',
      group: 'split',
      data: [
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.EntraId,    WsDeliverConfigSchemaMappingStatus.Ignore),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Exchange,   WsDeliverConfigSchemaMappingStatus.Ignore),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Intune,     WsDeliverConfigSchemaMappingStatus.Ignore),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SharePoint, WsDeliverConfigSchemaMappingStatus.Ignore),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Teams,      WsDeliverConfigSchemaMappingStatus.Ignore),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.OneDrive,   WsDeliverConfigSchemaMappingStatus.Ignore),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Planner,    WsDeliverConfigSchemaMappingStatus.Ignore),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SecurityCompliance,    WsDeliverConfigSchemaMappingStatus.Ignore),
      ]
    }, {
      name: 'ReadOnly',
      group: 'split',
      data: [
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.EntraId,    WsDeliverConfigSchemaMappingStatus.ReadOnly),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Exchange,   WsDeliverConfigSchemaMappingStatus.ReadOnly),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Intune,     WsDeliverConfigSchemaMappingStatus.ReadOnly),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SharePoint, WsDeliverConfigSchemaMappingStatus.ReadOnly),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Teams,      WsDeliverConfigSchemaMappingStatus.ReadOnly),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.OneDrive,   WsDeliverConfigSchemaMappingStatus.ReadOnly),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Planner,    WsDeliverConfigSchemaMappingStatus.ReadOnly),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SecurityCompliance,    WsDeliverConfigSchemaMappingStatus.ReadOnly),
      ]
    }, {
      name: 'Missing',
      group: 'split',
      data: [
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.EntraId,    WsDeliverConfigSchemaMappingStatus.Missing),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Exchange,   WsDeliverConfigSchemaMappingStatus.Missing),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Intune,     WsDeliverConfigSchemaMappingStatus.Missing),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SharePoint, WsDeliverConfigSchemaMappingStatus.Missing),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Teams,      WsDeliverConfigSchemaMappingStatus.Missing),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.OneDrive,   WsDeliverConfigSchemaMappingStatus.Missing),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.Planner,    WsDeliverConfigSchemaMappingStatus.Missing),
        getWorkloadMappingCount(workloadDataList, staticMappingList, mode, WsDeliverConfigWorkload.SecurityCompliance, WsDeliverConfigSchemaMappingStatus.Missing),
      ]
    }
  ];

  return series;
};












const WsCoverageChart = (props: {
  workloadDataList: WsWorkloadData[];
  staticMappingList: WsDeliverConfigSchemaMapping[];
  mode: string;
}) => {

  const options: ApexCharts.ApexOptions = {

    title: {
      text: props.mode
    },

    colors: [
      '#ff943d', // total
      // '#707070', // total
      // '#ff943d', // pending
      '#06a006', // mapped
      '#3b3bba', // review
      '#a1a1a1', // ignore
      '#8ba5ff', // read only
      '#C80100'  // missing
    ],

    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: false
      }
    },

    plotOptions: {
      bar: {
        horizontal: true,
        // dataLabels: {
        //   total: {
        //     enabled: true,
        //     offsetX: 0,
        //     style: {
        //       fontSize: '13px',
        //       fontWeight: 900
        //     }
        //   }
        // }
      },
    },

    stroke: {
      width: 1,
      colors: ['#fff']
    },

    xaxis: {
      categories: [ 'Entra ID', 'Exchange', 'Intune', 'SharePoint', 'Teams', 'OneDrive', 'Planner', 'SC' ],
      // labels: {
      //   formatter: function (val) {
      //     return val + "K"
      //   }
      // }
      min: 0,
      max: props.mode === 'Resources' ? 150 : 3200,
      tickAmount: 5
    },

    yaxis: {
      title: {
        text: undefined
      },
    },

    // tooltip: {
    //   // enabled: false,
    //   // y: {
    //   //   formatter: function (val) {
    //   //     return val + "K";
    //   //   }
    //   // }
    // },

    fill: {
      opacity: 1
    },

    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40
    }
  };

  const series = getSeries(props.workloadDataList, props.staticMappingList, props.mode);
  // console.log(series);

  return (
    <>
      <ReactApexChart
        series={series}
        options={options}
        type="bar"
        height={500}
      />
    </>
  );
};










const workloads: WsDeliverConfigWorkload[] = process.env.NODE_ENV === 'development'
  ?
  [
    WsDeliverConfigWorkload.EntraId,
    WsDeliverConfigWorkload.Exchange,
    WsDeliverConfigWorkload.Intune,
    WsDeliverConfigWorkload.OneDrive,
    WsDeliverConfigWorkload.Planner,
    // WsDeliverConfigWorkload.PowerPlatform,
    WsDeliverConfigWorkload.SharePoint,
    WsDeliverConfigWorkload.Teams,
    WsDeliverConfigWorkload.Office365,
    WsDeliverConfigWorkload.SecurityCompliance
  ]
  :
  [
    WsDeliverConfigWorkload.EntraId,
    WsDeliverConfigWorkload.Exchange,
    WsDeliverConfigWorkload.Intune,
    WsDeliverConfigWorkload.OneDrive,
    WsDeliverConfigWorkload.Planner,
    // WsDeliverConfigWorkload.PowerPlatform,
    WsDeliverConfigWorkload.SharePoint,
    WsDeliverConfigWorkload.Teams,
    WsDeliverConfigWorkload.Office365,
    WsDeliverConfigWorkload.SecurityCompliance
  ];




const WsResourcePage = (props: { view: string }) => {

  // const location = useLocation();

  const [ workloadDataList, setWorkloadDataList ] = useState<WsWorkloadData[] | undefined>(undefined);

  const [ staticMappingList, setStaticMappingList ] = useState<WsDeliverConfigSchemaMapping[] | undefined>(undefined);



  const getSchemaData = async (workload: WsDeliverConfigWorkload): Promise<WsWorkloadData> => {

    console.log('====================');
    console.log(`load data : ${workload.toLowerCase()}`);


    // source data

    const sourceResult = await apiGet(`/deliver/01903a3d-9408-7684-8552-c2258b002acb/${workload.toLowerCase()}/resource-schema?type=powershell`);

    if (sourceResult && Array.isArray(sourceResult)) {
      const sourceData = sourceResult as WsDeliverConfigSchemaItem[];
      // console.log(sourceData);


      // dsc data

      const dscResult = await apiGet(`/deliver/01903a3d-9408-7684-8552-c2258b002acb/${workload.toLowerCase()}/resource-schema`);

      if (dscResult && Array.isArray(dscResult)) {
        const dscData = dscResult as WsDeliverConfigSchemaItem[];
        // console.log(dscData);

        // nextWorkloadDataList.push({
        //   workload,
        //   sourceData, // getConfigSchemaList(sourceData),
        //   dscData     // getConfigSchemaList(dscData)
        // });

        return {
          workload,
          sourceData,
          dscData
        };

      } else {
        return {
          workload,
          sourceData: [],
          dscData:    []
        };
      }

    } else {
      return {
        workload,
        sourceData: [],
        dscData:    []
      };
    }
  };



  // load data

  useEffect(() => {

    // setWorkloadDataList(undefined);

    setTimeout(async () => {

      const nextWorkloadDataList: WsWorkloadData[] = [];



      try {

        const requests = workloads.map((workload: WsDeliverConfigWorkload) => {
          return getSchemaData(workload);
        });

        const results = await Promise.all(requests);

        nextWorkloadDataList.push(...results);

      } catch {
        console.error('ERROR: failed to load resource schema!');
      }

      setWorkloadDataList(nextWorkloadDataList);




      const mappingListResult = await apiGet(`/deliver/resource-mapping`);

      if (mappingListResult && Array.isArray(mappingListResult)) {
        const mappingListData = mappingListResult as WsDeliverConfigSchemaMapping[];
        const sortedMappingList = sortMappingList(mappingListData);
        console.log(sortedMappingList);
        setStaticMappingList(sortedMappingList);
      }



    }, 200);

  }, []);



  // render

  if (workloadDataList && staticMappingList) {

    if (props.view === 'DSC_COVERAGE') {

      return (
        <WsResourceCoverage
          workloadDataList={workloadDataList}
          staticMappingList={staticMappingList}
          // setResourcePanelVisible={setResourcePanelVisible}
        />
      );

    } else {

      return (
        <>
          <WsCoverageChart
            workloadDataList={workloadDataList}
            staticMappingList={staticMappingList}
            mode="Resources"
          />

          <WsCoverageChart
            workloadDataList={workloadDataList}
            staticMappingList={staticMappingList}
            mode="Fields (Resource Properties)"
          />
        </>
      );
    }

  } else {
    return(
      <Loading />
    );
  }
};






export {
  WsResourcePage
};
